import { Store } from "redux";
import {DefaultSettings} from '@alme/ui-web/settings/settings-util';
import {ResponseAction} from '@alme/types/response/ResponseAction';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';

export default class ResponseHandlerGoogleAnalytic{
    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    constructor(settings: any) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>) {
        this._store = store;
    }

    doesHandle(response: any) {
        return response.messageType === this._settings.messageConstants.converseRequest ||
            response.messageType === this._settings.messageConstants.requestUnitRequest ||
            response.messageType === this._settings.messageConstants.appeventRequest;
    }

    process(message: any) {
        if (!this.doesHandle(message)) return message;
        if (this.isArrayOfMessages(message)) return this.handleArrayOfMessages(message);

        message.response = this.processResponse(message.response);

        return message;
    }

    processResponse(response: any) {
        if (!response) return response;
        const responseActions = response?.responseActions?.filter((action: { Name: string; }) => action.Name === "GoogleAnalyticsTrackingForIVA");
        if(responseActions?.length > 0)
        {
            if (window.GATrackingForIVA) {
                window.GATrackingForIVA(responseActions[0].eventType, responseActions[0].eventAction, responseActions[0].eventLabel);
            }
        } 
        return response;
    }

    isArrayOfMessages( message: any ) {
        return Array.isArray(message.response);
    }

    handleArrayOfMessages( message: any ) {
        for (var i = 0, len = message.response.length; i < len; i++) {
            message.response[i] = this.processResponse(message.response[i]);
        }
        return message;
    }

}


// WEBPACK FOOTER //
// ./modules/response-handler-google-analytic/response-handler-google-analytic.ts